<template>
  <b-container fluid>
    <Card no-body title="Tasks">
      <b-list-group flush v-if="tasks.length">
        <b-list-group-item
          v-for="(task, index) in tasks"
          :key="`aison_import_task_item_${index}`"
        >
          <TaskItem v-model="tasks[index]" />
        </b-list-group-item>
      </b-list-group>
      <b-card-body v-else>
        A list of migration tasks (life import relations) will be shown here if
        accessible.
      </b-card-body>
    </Card>
  </b-container>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

import TaskItem from '@/components/TaskItem.vue';
import Card from '@/components/Card.vue';

export default defineComponent({
  name: 'Tasks',
  components: {
    Card,
    TaskItem,
  },
  computed: {
    ...mapGetters({
      tasks: 'task/tasks',
    }),
  },
});
</script>
